import { WIDGETS_PAGE_SIZE } from "common/constants";

export const WIDGET_CREATION_REQUESTED = "WIDGET_CREATION_REQUESTED";
export const WIDGET_CREATION_RECEIVED = "WIDGET_CREATION_RECEIVED";
export const WIDGET_CREATION_REQUEST_FAILED = "WIDGET_CREATION_REQUEST_FAILED";

export const WIDGET_BY_CODE_REQUESTED = "WIDGET_BY_CODE_REQUESTED";
export const WIDGET_BY_CODE_RECEIVED = "WIDGET_BY_CODE_RECEIVED";
export const WIDGET_BY_CODE_REQUEST_FAILED = "WIDGET_BY_CODE_REQUEST_FAILED";

export const WIDGET_DELETE_REQUESTED = "WIDGET_DELETE_REQUESTED";
export const WIDGET_DELETE_RECEIVED = "WIDGET_DELETE_RECEIVED";
export const WIDGET_DELETE_REQUEST_FAILED = "WIDGET_DELETE_REQUEST_FAILED";
export const WIDGET_DELETE_RESET = "WIDGET_DELETE_RESET";

export const WIDGET_SEND_EMAIL_REQUESTED = "WIDGET_SEND_EMAIL_REQUESTED";
export const WIDGET_SEND_EMAIL_RECEIVED = "WIDGET_SEND_EMAIL_RECEIVED";
export const WIDGET_SEND_EMAIL_REQUEST_FAILED = "WIDGET_SEND_EMAIL_REQUEST_FAILED";
export const WIDGET_SEND_EMAIL_RESET = "WIDGET_SEND_EMAIL_RESET";

export const WIDGETS_REQUESTED = "WIDGETS_REQUESTED";
export const WIDGETS_PRODUCTS_RECEIVED = "WIDGETS_PRODUCTS_RECEIVED";
export const WIDGETS_WIDGETS_RECEIVED = "WIDGETS_WIDGETS_RECEIVED";
export const WIDGETS_REQUEST_FAILED = "WIDGETS_REQUEST_FAILED";

export const WIDGET_PRODUCT_BY_CODE_REQUESTED = "WIDGET_PRODUCT_BY_CODE_REQUESTED";
export const WIDGET_PRODUCT_BY_CODE_RECEIVED = "WIDGET_PRODUCT_BY_CODE_RECEIVED";
export const WIDGET_PRODUCT_BY_CODE_REQUEST_FAILED = "WIDGET_PRODUCT_BY_CODE_REQUEST_FAILED";

export const requestWidget = productCode => ({
  type: WIDGET_BY_CODE_REQUESTED,
  id: productCode
});

export const receiveWidget = (productCode, payload) => ({
  type: WIDGET_BY_CODE_RECEIVED,
  id: productCode,
  payload
});

export const requestWidgetDelete = productCode => ({
  type: WIDGET_DELETE_REQUESTED,
  payload: { productCode }
});

export const receiveWidgetDelete = productCode => ({
  type: WIDGET_DELETE_RECEIVED,
  payload: { productCode }
});

export const resetWidgetDelete = () => ({ type: WIDGET_DELETE_RESET });

export const requestSendWidgetShareEmail = (productCode, payload) => ({
  type: WIDGET_SEND_EMAIL_REQUESTED,
  id: productCode,
  payload
});

export const receiveSendWidgetShareEmail = (productCode, payload) => ({
  type: WIDGET_SEND_EMAIL_RECEIVED,
  id: productCode,
  payload
});

export const resetSendWidgetShareEmail = () => ({
  type: WIDGET_SEND_EMAIL_RESET
});

export const requestWidgetCreation = productCode => ({
  type: WIDGET_CREATION_REQUESTED,
  id: productCode
});

export const receiveWidgetCreation = productCode => ({
  type: WIDGET_CREATION_RECEIVED,
  id: productCode,
  payload: { isCreationRequested: true }
});

export const requestWidgets = (pageNumber = 1, pageSize = WIDGETS_PAGE_SIZE) => ({
  type: WIDGETS_REQUESTED,
  pageNumber,
  pageSize
});

export const receiveWidgetProducts = (pageSize, pageNumber, total, items) => ({
  type: WIDGETS_PRODUCTS_RECEIVED,
  pageSize,
  pageNumber,
  total,
  items
});

export const receiveWidgetWidgets = items => ({
  type: WIDGETS_WIDGETS_RECEIVED,
  items
});

export const requestProductByCode = productCode => ({ type: WIDGET_PRODUCT_BY_CODE_REQUESTED, id: productCode });
export const receiveProduct = product => ({
  type: WIDGET_PRODUCT_BY_CODE_RECEIVED,
  payload: product,
  id: product.code
});
